import React, { useEffect, useState } from "react";
import type { FloorPlanProps } from "./floor-plan.tsx";
import { cn } from "../../../utils/cn.ts";

export const FloorPlanProxy: React.FC<FloorPlanProps> = ({
  floorPlanResourceUrl,
  isModalView,
  containerClass = "h-full w-full",
}) => {
  const [FloorPlanComponent, setFloorPlanComponent] = useState<React.FC<FloorPlanProps> | null>(null);
  const [isContentReady, setIsContentReady] = useState(false);

  useEffect(() => {
    if (!import.meta.env.SSR) {
      import("./floor-plan.tsx")
        .then((module) => {
          setFloorPlanComponent(() => module.FloorPlan);
        })
        .catch((err: unknown) => {
          console.log(err);
        });
    }
  }, []);

  return (
    <div className={cn(containerClass, "relative overflow-hidden bg-cloud")}>
      {FloorPlanComponent && (
        <FloorPlanComponent
          floorPlanResourceUrl={floorPlanResourceUrl}
          containerClass="h-full w-full"
          isModalView={isModalView}
          onReady={() => setIsContentReady(true)}
        />
      )}
      {!isContentReady && (
        <div
          className="absolute inset-0 bg-black/60 flex items-center justify-center z-20 pointer-events-none"
          role="status"
          aria-label="Loading floor plan"
        >
          <i
            className="fa-spinner-third fa-sharp fa-solid text-neutral-white text-[120px] animate-spin"
            aria-hidden="true"
          />
        </div>
      )}
    </div>
  );
};
